import React, { useState } from 'react';
import { Gift } from 'lucide-react';
import NotificationBellButton from '../NotificationBellButton';
import { hapticWave } from '../../utils/appFeedback';

export function GuestMapHeader({ firstName, currentDiscount }) {
  const [waving, setWaving] = useState(false);

  const handleWave = () => {
    if (waving) return;
    setWaving(true);
    // Haptic that follows the hand's 5-shake animation (135ms per shake, ~900ms total).
    hapticWave();
    window.setTimeout(() => setWaving(false), 900);
  };

  return (
    <div data-testid="guest-map-greeting" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: 'calc(env(safe-area-inset-top, 0px) + 18px) 20px 10px', flexShrink: 0 }}>
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <p data-testid="guest-map-hello" style={{ margin: 0, fontFamily: "'Inria Serif', serif", fontSize: 22, fontWeight: 700, color: 'var(--text)', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          Hey {firstName}{' '}
          <span
            role="button"
            tabIndex={0}
            aria-label="Wave hello"
            data-testid="guest-map-wave"
            onClick={handleWave}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWave(); } }}
            className={waving ? 'guest-map-wave-animate' : ''}
            style={{
              display: 'inline-block',
              cursor: 'pointer',
              transformOrigin: '70% 70%',
              userSelect: 'none',
              outline: 'none',
            }}
          >
            👋
          </span>
        </p>
        <p style={{ margin: '4px 0 0', fontFamily: "'Inria Serif', serif", fontSize: 13.5, fontWeight: 600, color: 'var(--text-2)', letterSpacing: '0.01em' }}>It&apos;s show time!</p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {currentDiscount != null && (
          <div
            data-testid="map-current-discount-pill"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 12px',
              borderRadius: 9999,
              background: 'linear-gradient(135deg, #1F8E2A, #138F4E)',
              color: '#FFFFFF',
              fontFamily: "'Inria Serif', serif",
              fontSize: 13,
              fontWeight: 700,
              boxShadow: '0 8px 18px rgba(31, 142, 42, 0.32)',
            }}
          >
            <Gift size={13} strokeWidth={2.4} />
            {currentDiscount}% off
          </div>
        )}
        <NotificationBellButton buttonTestId="guest-map-bell-button" popupTestId="guest-map-notification-popup" />
      </div>
    </div>
  );
}
